import React, { useEffect, useState, useRef } from "react";
import "./css/editProfile123.css";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import photo from "../../assets/images/icons/profile.png";
import { FiUsers } from "react-icons/fi";
import { CgOrganisation } from "react-icons/cg";
import { Avatar } from "@mui/material";
import FadeLoader from "react-spinners/FadeLoader";
import { useDispatch, useSelector } from "react-redux";
import { loadUser } from "../../actions/userActions";
import { logEvent } from "../../utils/Analytics";

const EditProfileCompany = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const dispatch = useDispatch();
  const [editable, setEditable] = useState(false);
  const { user } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [isFirstTime, setIsFirstTime] = useState(false);
  const [hasIncompleteOptionalFields, setHasIncompleteOptionalFields] =
    useState(false);
  const [hasShownInitialToast, setHasShownInitialToast] = useState(false);
  const [charCount, setCharCount] = useState(0);

  useEffect(() => {
  if (user && !hasShownInitialToast) {
    // Check if mandatory fields are missing (name or URL)
    const hasMissingMandatoryFields = !user.organisationName || !user.organisationURL;
    
    // Check if optional fields are incomplete (show toast if ANY is missing)
    const hasMissingOptionalFields = !user.organisationDescription && !user.organisationAvatar;

    setIsFirstTime(hasMissingMandatoryFields);
    setHasIncompleteOptionalFields(hasMissingOptionalFields);

    if (hasMissingMandatoryFields) {
      setEditable(true);
      toast.error("Please complete your organisation details", {
        position: "top-center",
        autoClose: 10000,
      });
      setHasShownInitialToast(true);
    } else if (hasMissingOptionalFields) {
      // Show info toast for optional fields when ANY is missing
      toast.warn("Please complete your organisation details", {
        position: "top-center",
        autoClose: 5000,
      });
      setHasShownInitialToast(true);
    }
  }
}, [user, hasShownInitialToast]);

  const [organisation, setOrganisation] = useState({
    email: "",
    organisationName: "",
    organisationDescription: "",
    organisationAvatar: "",
    organisationURL: user?.organisationURL || "",
  });

  const [logo, setLogo] = useState({
    orgLogo: "",
  });

  useEffect(() => {
    setOrganisation({
      ...organisation,
      email: user && user.email,
      organisationName: user && user.organisationName,
      organisationDescription: user && user.organisationDescription,
      organisationAvatar: "",
      organisationURL: user?.organisationURL || organisation.organisationURL,
    });

    // Set initial character count
    if (user && user.organisationDescription) {
      setCharCount(user.organisationDescription.length);
    }

    setLogo({
      ...logo,
      orgLogo:
        (user && user.organisationAvatar != undefined) || ""
          ? user.organisationAvatar.url
          : "",
    });
  }, [user]);

const handleOrganisationChange = (e) => {
  const { name, value } = e.target;

  // Check if it's the description field
  if (name === "organisationDescription") {
    setCharCount(value.length);
  }

  setOrganisation({
    ...organisation,
    email: user.email,
    [name]: value,
  });
};

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    const Reader = new FileReader();
    Reader.readAsDataURL(file);

    Reader.onload = () => {
      if (Reader.readyState === 2) {
        if (Reader.result) {
          setOrganisation({
            ...organisation,
            organisationAvatar: Reader.result,
          });

          setLogo({
            ...logo,
            orgLogo: Reader.result,
          });
        }
      }
    };
  };

 // Comprehensive URL validation
const isValidURL = (url) => {
  if (!url || typeof url !== 'string') return false;
  
  // Basic format check with regex first
  const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/;
  const localhostPattern = /^(https?:\/\/)?localhost(:\d+)?(\/\S*)?$/;
  
  if (!urlPattern.test(url) && !localhostPattern.test(url)) {
    return false;
  }
  
  // Additional validation using URL constructor
  try {
    const urlObj = new URL(url.startsWith('http') ? url : `https://${url}`);
    return ['http:', 'https:'].includes(urlObj.protocol) && 
           urlObj.hostname.length >= 3;
  } catch (error) {
    return false;
  }
};

  const handleUpate = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      // Validate organization name (MANDATORY)
      if (
        !organisation.organisationName ||
        !organisation.organisationName.trim()
      ) {
        toast.error("Please complete your organisation details", {
          position: "top-center",
        });
        setLoading(false);
        window.scrollTo(0, 0);
        return;
      }

      // Validate URL (MANDATORY)
      if (
        !organisation.organisationURL ||
        !organisation.organisationURL.trim()
      ) {
        toast.error("Please complete your organisation details", {
          position: "top-center",
        });
        setLoading(false);
        window.scrollTo(0, 0);
        return;
      }

      if (!isValidURL(organisation.organisationURL)) {
        toast.error("Please enter a valid URL", {
          position: "top-center",
        });
        setLoading(false);
        window.scrollTo(0, 0);
        return;
      }

      // Validate description character limit
      if (charCount > 3000){
        setLoading(false);
        window.scrollTo(0, 0);
        return;
      }

      const response = await axios.post("/api/user/updateorg", organisation);
      handleAddEvent("Update company details");

      if (response.status === 200) {
        setLoading(false);

        // Show success message
        toast.success("Organisation Details saved", {
          position: "top-center",
        });

        dispatch(loadUser());
        window.scrollTo(0, 0);
        setEditable(false);
        setIsFirstTime(false);
      } else {
        setLoading(false);
        toast.error(response.data.message || "Unable to update details", {
          position: "top-center",
        });
      }
    } catch (error) {
      setLoading(false);
      if (error.response) {
        toast.error(
          error.response.data.message ||
            "Server error: Unable to update details",
          { position: "top-center" }
        );
      } else if (error.request) {
        toast.error("Network error: Please check your connection", {
          position: "top-center",
        });
      } else {
        toast.error("Error: " + error.message, {
          position: "top-center",
        });
      }
    }
  };

  const [type, setType] = useState("button");
  const handleAddEvent = (str) => {
    logEvent("Button", `Clicked ${str} button`);
  };

  return (
    <>
      <div
        style={{
          backgroundColor: "white",
          height: "100%",
          width: "100%",
          paddingTop: "50px",
          paddingBottom: "50px",
        }}
      >
        <form onSubmit={handleUpate} className="profile-section123">
          <div className="d-flex align-items-center justify-content-center">
            <a
              href="/myProfile"
              onClick={() => handleAddEvent("Employer profile")}
            >
              <div className="logo">
                <FiUsers />
              </div>
            </a>
            <div
              style={{
                backgroundColor: "#00a5ec",
                width: "120px",
                height: "4px",
              }}
            ></div>
            <a
              href="/myProfile/company"
              onClick={() => handleAddEvent("Company profile")}
            >
              <div className="logo">
                <CgOrganisation />
              </div>
            </a>
          </div>

          <div className="d-flex align-items-center justify-content-center gap-5 mt-3">
            <span className="profile-section123-span">Personal Details</span>
            <span className="profile-section123-span">
              Organization Details
            </span>
          </div>

          {/* Organisation Details Section */}
          <h2 className="my-5 profile-section123-heading">
            Organization Details
          </h2>

          {!editable ? (
            <button
              onClick={() => {
                setEditable(true);
                document
                  .querySelector(
                    ".sub-section123 input[type='text']:first-of-type"
                  )
                  .focus();
              }}
              className="submit-btn123 mb-4"
              type="button"
            >
              Edit
            </button>
          ) : (
            <></>
          )}

          <div className="sub-section123">
            <div className="details w-100">
              <div className="title">Organization Name *</div>
              <input
                style={{
                  width: "100%",
                  border: "1px solid #ddd",
                  padding: "8px",
                  backgroundColor: `${editable ? "white" : ""}`,
                }}
                type="text"
                value={organisation?.organisationName}
                name="organisationName"
                onChange={handleOrganisationChange}
                onMouseOver="this.style.border='1px solid #00a5ec'"
                onMouseOut="this.style.border='1px solid #ddd'"
                placeholder="Organisation Name..."
                required
                disabled={!editable}
              />
            </div>

            <div className="details w-100">
              <div className="title">Organization description</div>
              <textarea
                style={{
                  height: "fit-content",
                  backgroundColor: `${editable ? "white" : ""}`,
                  width: "100%",
                  border: charCount >= 3000 ? "2px solid red" : "1px solid #ddd",
                  padding: "8px",
                }}
                type="text"
                placeholder="Description (optional)..."
                value={organisation?.organisationDescription}
                name="organisationDescription"
                onChange={handleOrganisationChange}
                rows={10}
                onMouseOver="this.style.border='1px solid #00a5ec'"
                onMouseOut="this.style.border='1px solid #ddd'"
                disabled={!editable}
                // maxLength={3000}
              ></textarea>
              <div
                style={{
                  textAlign: "right",
                  fontSize: "13px",
                  color: charCount >= 3000 ? "red" : "#8a8a8a",
                  marginTop: "0px",
                  fontFamily: "'Inter var',sans-serif",
                }}
              >
                Please limit your input to 3000 characters or less
              </div>
            </div>

            <div className="details w-100">
              <div className="title">Organization's website *</div>
              <input
                style={{
                  padding: "8px",
                  width: "100%",
                  border: "1px solid #ddd",
                  backgroundColor: `${editable ? "white" : ""}`,
                }}
                type="text"
                value={organisation?.organisationURL}
                name="organisationURL"
                onChange={handleOrganisationChange}
                onMouseOver="this.style.border='1px solid #00a5ec'"
                onMouseOut="this.style.border='1px solid #ddd'"
                placeholder="https://yourwebsite.com"
                disabled={!editable}
                required
              />
            </div>

            <div className="details">
              <div htmlFor="logo" className="title">
                Organization logo{" "}
                <span
                  className="small"
                  style={{ color: "#8a8a8a", fontSize: "12px" }}
                >
                  (Recommended)
                </span>
              </div>
              <div className="image-container p-4">
                <Avatar
                  src={logo && logo.orgLogo}
                  alt="User Avatar"
                  sx={{
                    height: "100px",
                    width: "auto",
                    "@media (max-width: 450px)": {
                      height: "auto",
                    },
                  }}
                  variant="square"
                />
              </div>
              {editable ? (
                <>
                  <label htmlFor="fileInput" className="custom-label">
                    Change Logo
                  </label>
                </>
              ) : (
                <>
                  <label className="custom-labeldesabled">Change Logo</label>
                </>
              )}

              <span
                style={{
                  color: "#8a8a8a",
                  fontSize: "14px",
                  fontFamily: "'Inter var',sans-serif",
                }}
              >
                Max file size: 1Mb and max resolution: 500px x 500px. File type:
                jpeg, jpg, png, gif, bmp
              </span>
              <input
                onChange={handleImageChange}
                type="file"
                id="fileInput"
                className="hidden-input"
                accept=".jpeg,.jpg,.png,.gif,.bmp"
                multiple="false"
                data-show-preview="false"
                data-show-upload="false"
                aria-invalid="false"
                capture="camera"
              />
            </div>
          </div>

          <div className="website">
            <div className="title mx-3">Organization verified</div>
            <div className="sub-title mx-3">
              Organization's website:{"  "}
              <a target="__blank" href={organisation.organisationURL}>
                {organisation.organisationURL}
              </a>
            </div>
          </div>
          {loading ? (
            <>
              <div
                className=""
                style={{ textAlign: "center", marginBottom: "-20px" }}
              >
                <FadeLoader color="#B3B3B3" />
              </div>
            </>
          ) : (
            <></>
          )}
          {editable ? (
            <>
              {loading ? (
                <>
                  <button
                    style={{
                      backgroundColor: "#B3B3B3",
                      border: "1px solid #B3B3B3",
                    }}
                    className="submit-btn123 mb-4"
                    type="button"
                  >
                    Save
                  </button>
                </>
              ) : (
                <>
                  <button
                    className="submit-btn123 mb-4"
                    type="button"
                    onClick={handleUpate}
                  >
                    Save & Continue
                  </button>
                </>
              )}
            </>
          ) : (
            <></>
          )}
        </form>
      </div>
      <ToastContainer position="top-center" autoClose={10000} />
    </>
  );
};

export default EditProfileCompany;
